<template>
  <div>
    <div
      style="height:190px;overflow:auto"
      class="d-flex flex-column justify-content-end"
    >
      <vue-custom-scrollbar style="height: 100%">
        <a-timeline class="mt-2">
          <a-timeline-item
            v-for="(entry, index) in log"
            :key="index"
          >
            <div class="text-gray-4 font-size-12 text-uppercase">
              {{ entry.date_created | dateFormatter('DD-MM-YYYY HH:mm') }}
            </div>
            <div>{{ $l(entry.status.title) }} <span v-if="entry.comment"> : <i>{{ entry.comment }}</i></span></div>
          </a-timeline-item>
        </a-timeline>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import dayjs from 'dayjs'

export default {
  name: 'OrderChangeLog',
  components: { vueCustomScrollbar },
  props: {
    log: {
      type: Array,
      default () {
        return []
      },
    },
  },
  methods: {
    dayjs,
  },
}
</script>
<style lang="scss" module>
@import "./styles/changelog.module";
</style>
